
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageSlug]/silhouette/[silhouette]",
      function () {
        return require("private-next-pages/[pageSlug]/silhouette/[silhouette].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageSlug]/silhouette/[silhouette]"])
      });
    }
  